const Constants = Object.freeze({
  GITHUB_PAGE_URL: "https://github.com/chagall/",
  LINKEDIN_PAGE_URL: "https://www.linkedin.com/in/fabio-alves-martins-pereira/",
  TWITTER_PAGE_URL: "https://twitter.com/commitblue/",
  MARIO_EMOJI_URL: "https://emoji.gg/assets/emoji/Mario.png",
});

export default Constants;